import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaAcRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaAcRepair} />; }
